import styled, { css } from 'styled-components'
import { Column, Image as BoltImage } from '@sainsburys-tech/bolt'

const StyledWrapper = styled(Column)`
  display: flex;
  flex-direction: row;
  height: 120px;
  border: ${(props) => props.theme.size.border.width.md} solid;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  margin-bottom: 15px;
  text-decoration: none;
  position: relative;
  overflow: hidden;
`

const StyledBanner = styled.div`
  color: ${(props) => props.theme.color.monochrome.white};
  position: absolute;
  padding: 2px 15px 5px 15px;
  height: 28px;
  top: 15px;
  right: 0;
  left: auto;
  z-index: 1;
  && {
    background-color: ${(props) => props.theme.color.monochrome.darker};
  }

  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 14px solid ${(props) => props.theme.color.monochrome.darker};
    border-bottom: 14px solid ${(props) => props.theme.color.monochrome.darker};
    border-left: 8px solid transparent;
    position: absolute;
    top: 0;
    left: -8px;
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    left: 0;
    right: auto;

    &::before {
      border-right: 8px solid;
      border-left: none;
      border-color: ${(props) => props.theme.color.monochrome.darker} transparent;
      left: auto;
      right: -8px;
    }
  }
`

const StyledBodyText = styled(Column)`
  align-items: flex-end;
  padding-right: 15px;
  color: ${(props) => props.theme.color.monochrome.darker};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    align-items: flex-start;
    padding-left: 15px;
    padding-right: 0;
  }
`

const StyledImageContainer = styled(Column)`
  max-width: 270px;
  background: no-repeat center center;
  background-size: contain;
  background-origin: content-box;
  display: block;
  position: relative;
  height: 120px;
  width: 100%;
  order: 1;
  overflow: hidden;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    max-width: 270px;
    order: 2;
  }
`

const StyledImage = styled(BoltImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;

  ${(props) =>
    props.modifier === 'mobile-left-center' &&
    css`
      object-position: left center;

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        object-position: center center;
      }
    `};
`

const StyledContentContainer = styled(Column)`
  padding: 10px 0;
  align-items: flex-start;
  margin-top: 43px;
  order: 2;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    order: 1;
  }
`

export { StyledWrapper, StyledBanner, StyledBodyText, StyledImageContainer, StyledImage, StyledContentContainer }
